import { defineStore } from "pinia";


export const useUser = defineStore('user',{
    state(){
        return {
            userInfo : {},
            companyInfo:{},
            menus: []
        }
    },
    getters: {
        isReadOnlyUser: (state) => !!state.userInfo?.readOnlyUser
    },
    actions: {
        updateInfo(data){
            this.userInfo = data
            localStorage.setItem('readOnlyUser', data?.readOnlyUser ? '1' : '0')
        },
    }
})